/**
 * Point.js
 * Created on 10-okt-2013
 * 
 * 
 * @author Reinier Feijen for Ranj
 **/

export default class Point {
    constructor(x, y) {
        this.x = x || 0;
        this.y = y || 0;
    }

    /**
     * Returns a clone of the Point instance.
     * @method clone
     * @return {Point} a clone of the Point instance.
     **/
    clone() {
        return new Point(this.x, this.y);
    }

    /**
     * Returns a string representation of this object.
     * @method toString
     * @return {String} a string representation of the instance.
     **/
    toString() {
        return `[Point (x=${this.x} y=${this.y})]`;
    }
}


Point.Distance = function(p1, p2) {
    var xDist = p1.x - p2.x;
    var yDist = p1.y - p2.y;
    return Math.sqrt(xDist * xDist + yDist * yDist);
};